type Props = {
  iconSize?: number
  textWidth?: number
  textHeight?: number
}

export function DownloadAPKIcon({ iconSize }: Props) {
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="1.5 1.5 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M7.48103 16.5C7.48103 16.968 7.80503 17.238 8.21903 17.238H8.95703V19.848C8.95703 20.442 9.47903 20.982 10.091 20.982C10.685 20.982 11.225 20.46 11.225 19.848V17.256H12.737V19.866C12.737 20.46 13.259 21 13.871 21C14.465 21 15.005 20.478 15.005 19.866V17.256H15.743C16.211 17.256 16.481 16.932 16.481 16.518V9.01195H7.48103V16.5ZM5.59103 9.01195C4.99703 9.01195 4.45703 9.53395 4.45703 10.146V15.42C4.45703 16.014 4.97903 16.554 5.59103 16.554C6.20303 16.554 6.72503 16.032 6.72503 15.42V10.146C6.72503 9.53395 6.20303 9.01195 5.59103 9.01195ZM18.407 9.01195C17.813 9.01195 17.273 9.53395 17.273 10.146V15.42C17.273 16.014 17.795 16.554 18.407 16.554C19.001 16.554 19.541 16.032 19.541 15.42V10.146C19.523 9.53395 19.001 9.01195 18.407 9.01195ZM14.609 4.61995L15.599 3.62995C15.743 3.48595 15.743 3.23395 15.599 3.10795C15.455 2.98195 15.203 2.96395 15.077 3.10795L13.943 4.24195C13.421 3.88195 12.737 3.73795 11.999 3.73795C11.261 3.73795 10.577 3.88195 9.98303 4.20595L8.92103 3.07195C8.77703 2.99995 8.45303 2.99995 8.32703 3.07195C8.25503 3.21595 8.25503 3.53995 8.32703 3.66595L9.31703 4.65595C8.25503 5.46595 7.51703 6.77995 7.51703 8.25595H16.535C16.517 6.74395 15.743 5.41195 14.609 4.61995ZM10.487 6.74395H9.74903V6.00595H10.487V6.74395ZM14.267 6.74395H13.529V6.00595H14.267V6.74395Z"
          fill="white"
        />
      </g>
    </svg>
  )
}
